import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import api from '@/services/api';

export default createStore({
  state: {
    isLoggedIn: false,
    authToken: null,
    user: null,
    companies: [],
    context: null,
  },
  getters: {
    hasPermission: (state) => (permission) => state.context?.permissions?.includes(permission),
    hasRole: (state) => (roleCode) => state.context?.roles?.some((role) => role.code === roleCode),
    activeCompany: (state) => state.context?.company || null,
    activeBranch: (state) => state.context?.branch || null,
    modules: (state) => state.context?.modules || [],
    hasModule: (state) => (moduleCode) => (state.context?.modules || []).some((module) => module.code === moduleCode),
  },
  mutations: {
    setSession(state, payload) {
      state.authToken = payload.auth_token || payload.authToken || state.authToken;
      state.user = payload.user || state.user;
      state.companies = payload.companies || state.companies;
      state.context = payload.context || state.context;
      state.isLoggedIn = !!state.authToken;
    },
    setContext(state, context) {
      state.context = context;
    },
    setCompanies(state, companies) {
      state.companies = companies || [];
    },
    clearSession(state) {
      state.isLoggedIn = false;
      state.authToken = null;
      state.user = null;
      state.companies = [];
      state.context = null;
    },
  },
  actions: {
    async initializeApp({ state, commit }) {
      if (!state.authToken) return;
      try {
        const { data } = await api.get('/api/auth/me');
        commit('setSession', data);
      } catch (_error) {
        commit('clearSession');
      }
    },
    async login({ commit }, credentials) {
      const { data } = await api.post('/api/auth/login', credentials);
      commit('setSession', data);
      return data;
    },
    async register({ commit }, form) {
      const { data } = await api.post('/api/auth/register', form);
      commit('setSession', data);
      return data;
    },
    async selectCompany({ commit }, payload) {
      const { data } = await api.post('/api/context/select-company', payload);
      commit('setContext', data.context);
      return data;
    },
    async logout({ commit }) {
      try {
        await api.post('/api/auth/logout');
      } catch (_error) {
        // Local logout still matters if the server session is gone.
      }
      commit('clearSession');
    },
  },
  plugins: [
    createPersistedState({
      paths: ['isLoggedIn', 'authToken', 'user', 'companies', 'context'],
    }),
  ],
});
